import {hoursSelect} from "../const/const";


const formatHours = (hours) => {
    if (hours !== null && hours !== undefined) {
        if (hoursSelect[hours]) {
            return hoursSelect[hours];
        }
    }
    return '';
}
export default formatHours;